import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

// ===============================
// RESET BUSINESS PASSWORD THUNK
// ===============================
export const resetBusinessPasswordRequest = createAsyncThunk(
  "resetBusinessPassword/send",
  async ({ email, otp, newPassword }, { rejectWithValue }) => {
    try {
      console.log("🚀 RESET PASSWORD API CALL START");
      console.log("📦 Payload:", { email, otp, newPassword });

      const response = await axios.post(
        `${baseUrl}/business/user/reset-password`,
        { email, otp, newPassword },
      );

      console.log("📡 API RESPONSE:", response.data);

      return {
        message: response.data?.message || "Success",
        success: true,
      };
    } catch (error) {
      console.log("❌ RESET PASSWORD ERROR:", error);

      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      console.log("⚠️ ERROR MESSAGE:", errorMsg);

      return rejectWithValue({
        message: errorMsg,
        success: false,
      });
    }
  },
);

// ===============================
// SLICE
// ===============================
const resetBusinessPasswordSlice = createSlice({
  name: "resetBusinessPassword",
  initialState: {
    loading: false,
    message: "",
    error: "",
    success: false,
  },

  reducers: {
    clearBusinessResetState: (state) => {
      console.log("🧹 RESET STATE CLEARED");
      state.loading = false;
      state.message = "";
      state.error = "";
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // ================= PENDING =================
      .addCase(resetBusinessPasswordRequest.pending, (state) => {
        console.log("⏳ RESET PASSWORD PENDING");
        state.loading = true;
        state.message = "";
        state.error = "";
        state.success = false;
      })

      // ================= FULFILLED =================
      .addCase(resetBusinessPasswordRequest.fulfilled, (state, action) => {
        console.log("✅ RESET PASSWORD SUCCESS");
        console.log("📩 Payload:", action.payload);

        state.loading = false;
        state.message = action.payload?.message || "";
        state.success = action.payload?.success || false;
        state.error = "";
      })

      // ================= REJECTED =================
      .addCase(resetBusinessPasswordRequest.rejected, (state, action) => {
        console.log("❌ RESET PASSWORD FAILED");
        console.log("📩 Error Payload:", action.payload);

        state.loading = false;
        state.error = action.payload?.message || "Reset failed";
        state.success = false;
      });
  },
});

export const { clearBusinessResetState } = resetBusinessPasswordSlice.actions;

export default resetBusinessPasswordSlice.reducer;
